import type { PropsWithChildren } from 'react';

export function FilterLayout({ children }: PropsWithChildren) {
    return <div className="flex w-full flex-col gap-3">{children}</div>;
}

export function FilterLayoutControls({ children }: PropsWithChildren) {
    return <div className="flex w-full flex-row flex-wrap gap-3 empty:hidden">{children}</div>;
}

export function FilterLayoutViews({ children }: PropsWithChildren) {
    return <div className="flex flex-row gap-3 overflow-auto scrollbar-none">{children}</div>;
}
